// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import {router} from './router/index';
import antDesignVue from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/styles/global.css';
import i18n from './local';
import Axios from 'axios';
Vue.prototype.$axios = Axios;

import Moment from 'moment';
Vue.prototype.$moment = Moment;
// vuex
import store from './store'
Vue.prototype.$store = store;

// 判断操作权限全局
import {hasOperate} from './libs/utils.js';
Vue.prototype.$hasOperate = hasOperate;

// 门店多选搜索组件
import FormItemVendorTreeSelect from './components/FormItemVendorTreeSelect.vue';
Vue.component('FormItemVendorTreeSelect', FormItemVendorTreeSelect);
// 表格列表筛选按钮全局
import TableColmnsBtn from './components/TableColmnsBtn.vue';
Vue.component('TableColmnsBtn', TableColmnsBtn);

// echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = function (el) {
  return echarts.init(el, null, {renderer: 'svg'})
}

Vue.use(antDesignVue)

import mixin from './libs/mixin.js';
Vue.mixin(mixin);

// 表示当前是使用mock模式来进行异步处理数据的
if (process.env.NODE_ENV === 'mock') {
  require('./api/mock/mock.js')
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store: store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js